export const appendAttachment = (formData, fieldName, attachment) => {
  if (!attachment) return;

  if (typeof attachment === 'string') {
    formData.append(fieldName, attachment);
    return;
  }

  if (attachment.url) {
    formData.append(fieldName, attachment.url);
    return;
  }

  if (typeof Blob !== 'undefined' && attachment instanceof Blob) {
    if (attachment.name) {
      formData.append(fieldName, attachment, attachment.name);
    } else {
      formData.append(fieldName, attachment);
    }
  }
};
